module.exports = __webpack_public_path__ + "img/connectivity_animation.855e9432.gif";